import React from 'react';
import './services.css';
import { Helmet } from "react-helmet";

import whatsapp from '../../Assets/whatsapp.png';
import call from '../../Assets/call.png';
import IndustrialPiercingImage from '../../Assets/Piercing Services/industrial piercing.png';
import Footer from '../contactus/contactus';

const handleWhatsAppClick = (message) => {
  const url = `https://wa.me/971567257579?text=${encodeURIComponent(message)}`;
  window.open(url, "_blank");
};

function IndustrialPiercing() {
  return (
    <div>
      <div className="earlobe-container">
        <Helmet>
          <title>Industrial Piercing UAE | 175-200 AED</title>
        </Helmet>

        <div className="floating-buttons">
          <div
            className='whatsapp-button'
            onClick={() => handleWhatsAppClick("I am interested in Industrial Piercing")}
          >
            <img src={whatsapp} alt="WhatsApp" />
          </div>

          <a href="tel:+971567257579" className="call-button">
            <img src={call} alt="Call" />
          </a>
        </div>

        <h1 className="earlobe-title">
          Industrial Piercing 175-200 AED
        </h1>

        <div className="earlobe-image-wrapper">
          <img src={IndustrialPiercingImage} alt="Industrial Piercing" />
        </div>

        <div className="earlobe-content">
          <h3>Industrial Piercing</h3>

          <p>
            Make a bold style statement with our professional industrial piercing services in the UAE, available at an affordable price range of 175–200 AED. Industrial piercing is a striking and modern ear piercing that consists of two cartilage piercings connected by a single barbell, creating a unique and edgy look. This piercing is perfect for individuals who want to stand out with a distinctive and fashion-forward style. Whether you are aiming for a minimal metallic finish or a bold statement piece, our expert specialists ensure precise alignment and placement for a visually balanced and aesthetically appealing result.
          </p>

          <p>
            At our piercing studio, safety, hygiene, and comfort are our top priorities. Our certified professionals use sterile, single-use, high-quality equipment to perform each industrial piercing with the highest level of care and precision. We strictly follow professional hygiene protocols to maintain a clean and sanitized environment, minimizing the risk of infection and ensuring a safe and smooth experience. Industrial piercing requires expertise due to its dual-point placement, and our trained specialists are skilled in executing the procedure accurately while minimizing discomfort.
          </p>

          <p>
            Industrial piercing is ideal for those who want to express individuality through a bold and creative ear design. It offers a strong visual impact and pairs well with other ear piercings, allowing you to create a customized and layered ear style. Our specialists take the time to understand your preferences and assess your ear structure to ensure that the piercing is suitable and placed correctly for both comfort and appearance. This personalized approach helps achieve the best possible results tailored to your unique style.
          </p>

          <p>
            The procedure is typically completed within a short time, though it involves two connected piercings. Our team uses advanced techniques designed to reduce pain and promote efficient healing, ensuring a comfortable experience throughout the process. We also provide high-quality, hypoallergenic barbell jewelry that is safe for sensitive skin, helping to prevent irritation and supporting a smooth healing journey.
          </p>

          <p>
            Our clean, welcoming, and professional environment ensures that every client feels relaxed and confident during their visit. We understand that industrial piercing can feel intimidating, especially for first-time clients, and our friendly staff is always available to guide you, answer your questions, and provide reassurance. From consultation to completion, we focus on delivering a positive and stress-free experience.
          </p>

          <p>
            Aftercare is especially important for industrial piercings due to their placement, and we provide detailed instructions to help you care for your piercing properly. Our specialists will guide you on cleaning routines, recommended products, and precautions to avoid infection or irritation. Following proper aftercare ensures better healing and helps maintain the appearance and health of your piercing.
          </p>

          <p>
            Our industrial piercing services in the UAE combine affordability with premium quality, offering transparent pricing with no hidden charges. Booking your appointment is quick and convenient, allowing you to choose a time that suits your schedule. We strive to provide minimal waiting time and a seamless experience from start to finish.
          </p>

          <p>
            Choose our trusted industrial piercing services in the UAE for a safe, stylish, and professional experience. With experienced specialists, precise techniques, and a commitment to customer satisfaction, we help you achieve a bold and striking look effortlessly. Book your industrial piercing appointment today and redefine your ear style with confidence and expert care.
          </p>

          <button
            className="book-btn"
            onClick={() => handleWhatsAppClick("I want to book Industrial Piercing")}
          >
            Book Now
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default IndustrialPiercing;